import { Box } from "@mui/material"
import { groupBy, isNil } from "lodash"
import { useState } from "react"
import ArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ArrowRight from '@mui/icons-material/KeyboardArrowRight';
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton";
import GenericModal from "../../core/components/base/GenericModal";
import { ReworkDragDropItemTracker } from "./ReworkitemTracker";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import { useDispatch } from "react-redux";
import { setCheckLocation } from "../OotrReducer";


interface CheckLocation {
    location: string,
    num: number
}

export const CratesChecks: Array<CheckLocation> = [
    {location: "GV Child near Cow", num: 1},
    {location: "GV PoH Crate", num: 1},
    {location: "Hidehout Above GTG (2)", num: 2},
    {location: "Hidehout below skull (3)", num: 2},
    {location: "Hidehout Kitchen next SoS", num: 5},
    {location: "Hidehout below Scarecrow (Break)", num: 4},
    {location: "Hidehout after Break Room", num: 1},
    {location: "Wasteland Near Fortress", num: 1},
    {location: "Wasteland after Quicksand", num: 3},
    {location: "Wasteland near Coloss", num: 1},
    {location: "Market Slingshot Night", num: 2},
    {location: "Market Bazar Night", num: 2},
    {location: "Market Kiki", num: 1},
    {location: "Market Bridge Guard House", num: 1},
    {location: "Kak Adult Red Rupee", num: 2},
    {location: "Kak Adult Archery", num: 1},
    {location: "Kak Adult Mendiant", num: 2},
    {location: "LLR Child near tree", num: 2},
    {location: "Jabu Elevator Crate", num: 2},
    {location: "Fire Hammer Stairs", num: 2},
    {location: "Spirit Child before door", num: 2},
]
export const FreestandingChecks: Array<CheckLocation> = [
    {location: "KF Behind Mido Child", num: 1},
    {location: "KF Boulder Maze Child", num: 2},
    {location: "KF Bridge Child", num: 1},
    {location: "KF Top Saria Child", num: 3},
    {location: "KF Bush Ramp", num: 2},
    {location: "KF Mido Ramp", num: 2},
    {location: "KF Above Bean", num: 7},
    {location: "KF Saria House", num: 4},
    {location: "KF Kokiri Shop", num: 1},
    {location: "LW Boulder", num: 1},
    {location: "LW shortcut river", num: 8},
    {location: "LH near RL", num: 3},
    {location: "LH Lab", num: 3},
    {location: "GY Dampe Race", num: 8},
    {location: "DMT Climb Boulder Child", num: 2},
    {location: "GC Pot", num: 8},
    {location: "DMC Adult Pierre", num: 7},
    {location: "DMC Child", num: 7},
    {location: "ZR Waterfall", num: 4},
    {location: "ZD front KZ Beehive", num: 2},
    {location: "ZD behind KZ Beehive", num: 1},
    {location: "ZF Bottom", num: 18},
    {location: "DMT Cow Grotto", num: 11},
    {location: "GV Octorock Grotto", num: 8},
    {location: "Deku Low Plank", num: 1},
    {location: "Deku High Jump", num: 1},
    {location: "Deku 231", num: 3},
    {location: "DC Lower Lizalfos lavafall", num: 1},
    {location: "DC Upper Lizalfos column", num: 1},
    {location: "DC Maze Behind block", num: 1},
    {location: "Forest well", num: 1},
    {location: "Forest Courtyard Column", num: 1},
    {location: "Fire Elevator", num: 3},
    {location: "Fire Eye Switch", num: 3},
    {location: "Fire Moving Fire", num: 3},
    {location: "Water River", num: 4},
    {location: "Shadow Invisible Blade (SoT)", num: 2},
    {location: "Shadow Pierre before Boat", num: 2},
    {location: "Shadow Pierre after Boat", num: 2},
    {location: "Shadow before Boss", num: 1},
    {location: "Shadow 3 Pots", num: 9},
    {location: "Spirit Wall of Shame", num: 2},
    {location: "Ganon Fire Trial near F3", num: 1},
    {location: "Ganon Shadow Trial after f3", num: 1},
    {location: "Ganon Spirit Trial", num: 1},
    {location: "BotW Coffin", num: 2},
    {location: "BotW Middle fall", num: 5},
    {location: "GTG Beamos", num: 2},
    {location: "Ice Freezards", num: 1},
    {location: "Ice Map", num: 3},
    {location: "Ice Blocks (SoT)", num: 3},
    {location: "Grotto Generic Beehive", num: 2},
    {location: "Grotto 2 Scrub Beehive", num: 1},
    {location: "Grotto 3 Scrub Beehive", num: 1},
]
export const PotsChecks: Array<CheckLocation> = [
    {location: "KF Link house", num: 1},
    {location: "KF House of Twins", num: 2},
    {location: "KF Know it all", num: 2},
    {location: "Hidehout 1 Torch", num: 3},
    {location: "Hidehout 2 Torch", num: 7},
    {location: "Hidehout 4 Torch", num: 2},
    {location: "Hidehout Kitchen", num: 2},
    {location: "Hidehout Break Room", num: 2},
    {location: "Market Guard House", num: 44},
    {location: "Market Poe House", num: 7},
    {location: "Market Back Alley", num: 3},
    {location: "Kak Near Potion Shop Child", num: 3},
    {location: "Kak Near Bazaar Shop Child", num: 3},
    {location: "Kak Near Impa House Shop Child", num: 3},
    {location: "Kak Near Old Hag Child", num: 2},
    {location: "GY Dampe Race", num: 6},
    {location: "GC Lower Stairs", num: 2},
    {location: "GC Upper Stairs", num: 3},
    {location: "GC Medigoron", num: 1},
    {location: "GC Darunia", num: 3},
    {location: "DMC near GC", num: 4},
    {location: "ZF F2 Cave", num: 3},
    {location: "ZF Jabu", num: 4},
    {location: "LLR Front Child", num: 4},
    {location: "LLR Shed", num: 4},
    {location: "LLR Talon", num: 4},
    {location: "HF Cow Grotto", num: 2},
    {location: "HC Sos Grotto", num: 4},
    {location: "DC Scarecrow", num: 2},
    {location: "DC Corridor", num: 2},
    {location: "DC Lizalfos Lower", num: 2},
    {location: "DC Baby Dodongo", num: 4},
    {location: "DC Stairs", num: 6},
    {location: "DC Near Bomb Bag", num: 2},
    {location: "DC Eye Switch 1", num: 2},
    {location: "DC Eye Switch 2", num: 2},
    {location: "DC Last Block", num: 2},
    {location: "Jabu Basement", num: 3},
    {location: "Jabu Basement Wiggler", num: 3},
    {location: "Jabu Big Octo", num: 3},
    {location: "Jabu Barinade", num: 6},
    {location: "Forest Central Chamber", num: 6},
    {location: "Forest Lower Stalfos", num: 2},
    {location: "Forest Upper Stalfos", num: 4},
    {location: "Forest Blue Poe", num: 3},
    {location: "Forest Frozen Eye", num: 3},
    {location: "Forest Green Poe", num: 2},
    {location: "Fire Near Boss", num: 4},
    {location: "Fire Big Lava Room (top left platform)", num: 3},
    {location: "Fire Left Fire Maze", num: 2},
    {location: "Fire Rigth Fire Maze", num: 3},
    {location: "Fire Hammer Staircase", num: 2},
    {location: "Water Main Room L2 Right", num: 2},
    {location: "Water L1 Torch", num: 2},
    {location: "Water Behind Gate", num: 2},
    {location: "Water Compass", num: 2},
    {location: "Water BK Block Puzzle", num: 2},
    {location: "Water Like Like", num: 2},
    {location: "Water River Pot", num: 1},
    {location: "Shadow Map Chest", num: 2},
    {location: "Shadow Early Fake Wall", num: 2},
    {location: "Shadow After Fake Wall Left", num: 2},
    {location: "Shadow Before Deadhand", num: 2},
    {location: "Shadow Before Boat Gibdo", num: 4},
    {location: "Shadow After Boat", num: 2},
    {location: "Shadow Wooden Fence", num: 1},
    {location: "Shadow Floormaster", num: 2},
    {location: "Shadow Near Boss", num: 2},
    {location: "Spirit Lobby", num: 4},
    {location: "Spirit Lower Child Bridge", num: 1},
    {location: "Spirit Lower Child Anubis", num: 1},
    {location: "Spirit Before Child Climb", num: 2},
    {location: "Spirit Child Climb", num: 1},
    {location: "Spirit Adult Climb", num: 3},
    {location: "Spirit Central Chamber", num: 2},
    {location: "Spirit Beamos Hall", num: 1},
    {location: "Spirit Before Child Knuckles", num: 1},
    {location: "Spirit Adult Big Mirror", num: 8},
    {location: "Trial Forest End", num: 2},
    {location: "Trial Fire End", num: 2},
    {location: "Trial Water End", num: 2},
    {location: "Trial Shadow Like Like", num: 2},
    {location: "Trial Shadow End", num: 2},
    {location: "Trial Spirit End", num: 2},
    {location: "Ganon's Tower", num: 14},
    {location: "Botw Entrance", num: 2},
    {location: "Botw Entrance Left", num: 3},
    {location: "Botw Left Skull", num: 2},
    {location: "Botw Underwater", num: 1},
    {location: "Botw Fire Keese", num: 1},
    {location: "Botw Basement", num: 12},
    {location: "Ice after Freezard", num: 3},
    {location: "Ice Spinning Blade", num: 4},
    {location: "Ice Map Forzen", num: 1},
    {location: "Ice Frozen Before End", num: 2}
]

interface CheckTrackerProps{
    checks: Array<CheckLocation>
}
const CheckTracker = (props: CheckTrackerProps) => {

    let dic = groupBy(props.checks, x => x.location.split(" ")[0])

    let [done, setDone] = useState<Array<string>>([])

    const addRemoveLocationDone = (v: string) => {

        if(done?.includes(v))
            setDone([...done.filter(x => x !== v)])
        else
            setDone([...done, v])
    }
    return  <Box display={"flex"} flexDirection={"column"} height={"280px"} flexWrap={"wrap"} marginLeft={"25px"}>
        {Object.keys(dic).map((k) => {
            return <CheckRegionTracker checks={dic[k]} location={k} done={done} setDone={addRemoveLocationDone}/>
        })}
    </Box>
}

export default CheckTracker;


interface CheckRegionTrackerProps {
    checks: Array<CheckLocation>
    location: string
    done: Array<string>
    setDone: (v: string) => void
}
const CheckRegionTracker = (props: CheckRegionTrackerProps) => {

    let [open, setOpen] = useState(false)
    let regionCheck = props.checks.every(x => props.done.includes(x.location));

    let nbChecksLeft = props.checks.filter(x => !props.done.includes(x.location)).map(x => x.num).reduce((a,b) => a+b);

    return <Box display={"flex"} flexDirection={"column"} minWidth={"100px"}>
        <Box display={"flex"} onClick={() => setOpen(!open)}>
            <Box sx={{textDecoration: regionCheck ? "line-through" : "inherit", opacity: regionCheck ? 0.5 : 1, color: regionCheck ? "rgb(240, 74, 74)" : "inherit"}}>{props.location}  {nbChecksLeft}</Box>
            <Box >{open ? <ArrowDown /> : <ArrowRight /> }</Box>
        </Box>
        <GenericModal open={open} handleClose={(v) => setOpen(false)} width={600}>
            <Box display={"flex"} flexDirection={"row"}>
                <Box display={"flex"} position={"relative"}>
                    <ReworkDragDropItemTracker left={0} top={0} />
                </Box>
                <Box display={"flex"} flexDirection={"column"} >
                    {props.checks.map(p => {

                        return <CheckLocationTracker check={p} done={props.done} setDone={props.setDone}/>
                    })}
                </Box>
            </Box>
           
        </GenericModal>
    </Box>
}


interface CheckLocationTrackerProps {
    check: CheckLocation
    done: Array<string>
    setDone: (v: string) => void
}

const CheckLocationTracker = (props: CheckLocationTrackerProps) => {

    let {check} = props;

    let items = useSelector((state: AppState) => state.ui.ootr.main.checkLocations?.[check.location])

    console.log(check.location, items)
    if(isNil(items) || items?.length === 0)
        items = [null, null, null, null]
    else if(items?.length === 1)
        items = [...items, null, null, null]
    else if(items?.length === 2)
        items = [...items, null, null]
    else if(items?.length === 3)
        items = [...items, null]
    else
        items = [items[0], items[1], items[2], items[3]]

    let dispatch = useDispatch()

    let isCheck = props.done.includes(check.location);

    return <Box display={"flex"} 
                flexWrap={"wrap"} 
                justifyContent={"space-between"} 
                sx={{textDecoration: isCheck ? "line-through" : "inherit", opacity: isCheck ? 0.5 : 1, color: isCheck ? "rgb(240, 74, 74)" : "inherit"}} 
                onClick={() => props.setDone(check.location)}
                width={"280px"}
            >
                <Box>{check.location}</Box> 
                <Box> - </Box>
                <Box>{check.num}</Box> 
                <Box display={"flex"} width={"70px"}>
                    <OotItemContextMenuButton item={items[0]} onItemChange={(v) => dispatch(setCheckLocation({loc: check.location, items: [v, items[1], items[2], items[3]]}))}  />
                    <OotItemContextMenuButton item={items[1]} onItemChange={(v) => dispatch(setCheckLocation({loc: check.location, items: [items[0], v, items[2], items[3]]}))}  />
                    <OotItemContextMenuButton item={items[2]} onItemChange={(v) => dispatch(setCheckLocation({loc: check.location, items: [items[0], items[1], v, items[3]]}))}  />
                    <OotItemContextMenuButton item={items[3]} onItemChange={(v) => dispatch(setCheckLocation({loc: check.location, items: [items[0], items[1], items[2], v]}))}  />
                </Box>
            </Box>
}